import firebase from "firebase";
import "firebase/firestore";
//import 'firebase/auth'

// Your web app's Firebase configuration
var firebaseConfig = {
	apiKey: "AIzaSyDyoRjsp1VeFJpQ-7xkWXhh97wDR5fPDc8",
	authDomain: "ukforms-764a8.firebaseapp.com",
	databaseURL: "https://ukforms-764a8.firebaseio.com",
	projectId: "ukforms-764a8",
	storageBucket: "ukforms-764a8.appspot.com",
	messagingSenderId: "318262446196",
	appId: "1:318262446196:web:61039d05c1e01bd1",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
var storage = firebase.storage();
const auth = firebase.auth();
//var test= {database: db, storage: storage}
// const storageService = firebase.storage();
// const storageRef = storageService.ref();

//db.settings({timestampsInSnapshots: true});

export { db, storage, auth };
